import GeoService from 'web-core/src/geo-service';
import clientConf from '../conf';

export const RECEIVE_ADDRESS_FROM_ZIP = 'RECEIVE_ADDRESS_FROM_ZIP';

export const receiveAddressFromZip = data => ({
  type: RECEIVE_ADDRESS_FROM_ZIP,
  data,
});

const getConf = () => ({
  path: {
    searchBase: `${clientConf.MARKETPLACE_BASE_URL}/v1`,
  },
});

// TODO: deprecate, use marketplace-api query instead
export const getAddressFromZip = (zipcode, options) => (dispatch, getState, { apiClient }) => {
  const svc = new GeoService({ client: apiClient, conf: getConf() });
  return svc.getByZip(zipcode, options).then((response) => {
    dispatch(receiveAddressFromZip(response));
    return response;
  });
};

export const getMedicaidAndChipUrls = stateCode => (dispatch, getState, { apiClient }) => {
  const svc = new GeoService({ client: apiClient, conf: getConf() });
  return svc.getMedicaidAndChipUrls(stateCode);
};
